import { cssClass } from '~src/style';

import { imgUrl } from '../../utils/ImgUrl';

const cssPrefix = 'preview';
export const imageContent = cssClass(cssPrefix, 'imageContent', {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 600,
  });

  export const dqwImageContent = cssClass(cssPrefix, 'dqwImageContent', {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 500,
  });

export const listWrapper = cssClass(cssPrefix, 'listWrapper', {
    listStyleImage: imgUrl('check_12px-xsmall.svg'),
    paddingInlineStart: 20,
    $nest: {
      'li': {
        padding: '8px 4px',
      }
    }
  });

export const header = cssClass(cssPrefix, 'header', {
    fontSize: 18,
    paddingBottom: 12,
  });

export const buttonWrapper = cssClass(cssPrefix, 'buttonWrapper', {
    display: 'flex',
    gap: 8
  });

export const textContent = cssClass(cssPrefix, 'textContent', {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 380,
  });

  export const dqwTextContent = cssClass(cssPrefix, 'dqw-textContent', {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 400,
  });

export const wrapper = cssClass(cssPrefix, 'wrapper', {
  display: 'flex',
  padding: 40,
  gap: 40,
});

export const dqwWrapper = cssClass(cssPrefix, 'dqw-wrapper', {
  display: 'flex',
  padding: 10,
  gap: 40,
});

export const dqwImage = cssClass(cssPrefix, 'dqw-preview-image',{
  boxShadow:'0px 0px 10px #d1cfcf',
  width: 500
});
